module.exports = __webpack_public_path__ + "static/media/check.4146a8b4.svg";